import React, { useState } from 'react';
import { Tabs } from 'antd';
import { ExternalTransfer } from '@/components/ExternalTransfer/ExternalTransfer';
import { SubPanelType } from '@/pages/Active/Active';
import { AgentList } from '@/components/AgentList/AgentList';
import { SipJs } from '@/services/sip-js.service';
import './TabGroup.scss';

export interface TabGroupProps {
  mode: SubPanelType;
}

export function TabGroup({ mode }: TabGroupProps) {
  const [activeKey, setActiveKey] = useState(SipJs.conference ? '2' : '1');
  let tabItems = [];
  let tabGroupHeader = '';

  const handleTabChange = (activeKey: string) => {
    setActiveKey(activeKey);
  };

  switch (mode) {
    case 'groupCall':
      tabGroupHeader = 'Group call';
      tabItems = [
        {
          label: 'Invite',
          children: (
            <AgentList
              mode="addToGroupCall"
              setActiveTab={handleTabChange}
              multipleSelect
            />
          ),
          key: '1',
        },
        {
          label: 'Participants',
          children: <AgentList mode="onCall" multipleSelect />,
          key: '2',
        },
      ];
      break;
    case 'transfer':
    default:
      tabGroupHeader = 'Transfer a call';
      tabItems = [
        {
          label: 'Internal Transfer',
          children: <AgentList mode="transfer" />,
          key: '1',
        },
        {
          label: 'External Transfer',
          children: <ExternalTransfer />,
          key: '2',
        },
      ];
  }

  return (
    <div className="transfer">
      <div className="main-text transfer__header">{tabGroupHeader}</div>
      <div className="transfer__main">
        <Tabs
          data-testid="group-call-tabs"
          activeKey={activeKey}
          items={tabItems}
          onChange={handleTabChange}
          destroyInactiveTabPane
        />
      </div>
    </div>
  );
}
